module.exports = __webpack_public_path__ + "static/banner_hero-image1-cf3dd50e1126918600205e739fab5655.png";